import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// var swiper = new Swiper(".mySwiper", {
//   observer: true,//修改swiper自己或子元素时，自动初始化swiper
//   observeParents: true,//修改swiper的父元素时，自动初始化swiper
//     direction: 'vertical',
//     slidesPerView: 4,
//     freeMode: true,
//     watchSlidesProgress: true,
//   });
  var swiper2 = new Swiper(".mySwiper2", {
    observer: true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents: true,//修改swiper的父元素时，自动初始化swiper
    // thumbs: {
    //   swiper: swiper,
    // },
  });
  $(".house-nav li:first").addClass("active");
  $(".house-nav li").click(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    swiper2.slideTo(index, 1000, false);
})